module.exports = __webpack_public_path__ + "images/banner.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = 1056
// module chunks = 17